import { httpClient } from '@/shared/services';
import type {
  Job,
  JobsListResponse,
  JobFilters,
  StartTranslationRequest,
  StartTranslationResponse,
  UrlCheckResult,
} from '../types/jobs.types';

export const jobsService = {
  list: async (filters: JobFilters = {}): Promise<JobsListResponse> => {
    const params = new URLSearchParams();
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.search) params.append('search', filters.search);

    const response = await httpClient.get<JobsListResponse>(`/v1/jobs?${params}`);
    return response.data;
  },

  getById: async (jobId: string): Promise<Job> => {
    const response = await httpClient.get<Job>(`/v1/jobs/${jobId}`);
    return response.data;
  },

  getDetails: async (jobId: string, search?: string): Promise<Job> => {
    const params = search ? `?search=${encodeURIComponent(search)}` : '';
    const response = await httpClient.get<Job>(`/v1/jobs/${jobId}/details${params}`);
    return response.data;
  },

  cancel: async (jobId: string): Promise<{ success: boolean; job: Job }> => {
    const response = await httpClient.post<{ success: boolean; job: Job }>(
      `/v1/jobs/${jobId}/cancel`
    );
    return response.data;
  },

  checkTranslations: async (
    urls: string[],
    targetLang: string
  ): Promise<{ results: UrlCheckResult[] }> => {
    const response = await httpClient.post<{ results: UrlCheckResult[] }>(
      '/v1/translations/check',
      { urls, targetLang }
    );
    return response.data;
  },

  startTranslation: async (
    request: StartTranslationRequest
  ): Promise<StartTranslationResponse> => {
    const response = await httpClient.post<StartTranslationResponse>(
      '/v1/translations',
      request
    );
    return response.data;
  },

  getWebSocketUrl: (jobId: string): string => {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const host = import.meta.env.VITE_API_WS_URL || window.location.host;
    return `${protocol}//${host}/v1/jobs/${jobId}/ws`;
  },
};
